var Actions;
(function (Actions) {
    Actions["GET_PBI_CONFIG"] = "getPbiConfig";
    Actions["POST_PBI_CONFIG"] = "postPbiConfig";
    Actions["GET_MINING_PBI_ROLE"] = "getMiningPbiRole";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_PBI_CONFIG"] = "setPbiConfig";
    Mutations["SET_LOADING"] = "setLoading";
    Mutations["SET_PBI_URL"] = "setPBIUrl";
    Mutations["SET_IS_PBI_URL_COMPLETE_URL"] = "setIsPBIUrlCompleteUrl";
    Mutations["SET_PBI_MINING_ROLE"] = "setPbiMiningRole";
    Mutations["SET_FIRST_INIT"] = "setPbiFirstInit";
    Mutations["SET_DATE_FILTER"] = "setDateFilter";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
